import { useState, useEffect } from "react";

function Report() {
  const [data, setData] = useState();

  useEffect(() => {
    processReadEdit();
  }, []);

  const processReadEdit = () => {
    let item = localStorage.getItem("searchResult");
    if (item) {
      localStorage.removeItem("searchResult");
      let data = JSON.parse(item);
      if (data) {
        console.log(data.records);
        setData(data.records);
      }
    }
  };

  return (
    data &&
    data.map((x, i) => (
      <div className="report-row">
        <div className="report-col">
          <table key={i} width="100%">
            <tbody>
              <tr>
                <td>
                  <b>{x.applicationNumber}</b>
                </td>
              </tr>
              <tr>
                <td>{`${x.address_1}${x.address_2 ? ", " + x.address_2 : ""}${
                  x.address_3 ? ", " + x.address_3 : ""
                },`}</td>
              </tr>
              <tr>
                <td>{x.customArea}</td>
              </tr>
              <tr>
                <td>{`${x.area}, ${x.taluka}, ${x.district},`}</td>
              </tr>
              <tr>
                <td>{`${x.state}, (${x.pincode})`}</td>
              </tr>
              <tr>
                <td>{`Mobile - ${x.mobile}`}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ))
  );
}

export default Report;
